<template>

  <base-subscription-form/>

</template>


<script >
import BaseSubscriptionForm from "@/plugin/components/dashboard/AllSubscription/BaseSubscriptionForm.vue";

export default {
  name: "UpdateSubscription",
  components: {BaseSubscriptionForm},


}

</script>


<style scoped>

</style>